import Icon from "icons"
import styled from "styled-components"

export const SupplementsShortIcon = styled(Icon)`
  color: ${(props) => props.theme.colors.supplements};
  margin-top: -0.5rem;

  /* IE 11 */
  max-height: 1.8rem;
`

export const SupplementsCategory = styled.div`
  color: ${(props) => props.theme.colors.supplements};
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
`

export const SupplementsLogo = styled.div`
  font-size: 2rem;
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;

  ::before {
    content: "Mbg";
  }

  ::after {
    color: ${(props) => props.theme.colors.supplements};
    content: "Shop";
  }
`

export const BottomRight = styled.div`
  background: #fff;
  border-radius: 100% 0 0 0;
  padding: 1.5rem 1rem 0.5rem 1.8rem;
  color: #bbbbbb;
`
